export enum eContentType {
    PlainText = "PlainText",
    ImageResponseCard = "ImageResponseCard"
}